module.exports = __webpack_public_path__ + "img/emoji_03.7550f8d9.png";